import { ENV } from './types';

const API_ENV = 'release';

const ACORE_DOMAIN: string = '//test3.yx.jd.com';

const TREND_DOMAIN: string = '//yx.jd.com';

const HD_API_DOMAIN: string = '//pre-actcenter.jd.com';

const HD_API_TOOL_DOMAIN: string = '//asta.jd.com';

// 生产http会重定向到https所以改成https
// 提报准线上环境
const MC_DOMAIN: string = 'http://pre.mc.jd.com';

const MC_LOWCODE_PAGE = {
  substituteRegistration: 49, // 代报名管理
};

const MAC_DOMAIN: string = '//pre-mac.jd.com';

const ACE_DOMAIN: string = '//rc.ace.jd.com';

const ACE_API_DOMAIN: string = 'https://material.jd.com';

const BABEL_DOMAIN: string = 'https://babel.m.jd.com';

const LINGLONG_DOMAIN: string = 'https://ling.jd.com';

const BABELPRO_DOMAIN: string = 'https://pro.m.jd.com';

const BABELPRO_PC_DOMAIN: string = 'https://pro.jd.com';

const BABELPRO_PARAMS: string = '';

const CELUE_DOMAIN = '//smartmind.jd.com';

const QYPT_DOMAIN = '//qypt.jd.com';

const WAREOPS_DOMAIN = '//ioc.jd.com';
const DATA_CENTER_DOMAIN = '//markingcenter.jd.com';
const EASYBI_DOMAIN = '//easybi.jd.com';
const EASYBI_URL_DOMAIN = 'https://easybi.jd.com';

const BAICHUAN_DOMAIN = '//bcms.jd.com/0/welcome';
const SECKILLCMS_DOMAIN = '//seckillcmsyx.jd.com';
const DRIPWORKS_DOMAIN = '//dripworks-yx-pro.pf.jd.com';
const DRIPWORKS_DOMAIN_SYSTEM = 'https://dripworks-cqrh8wra-pro.local-pf.jd.com';

const NEWPROCESS = '//dripworks-111-pro.pf.jd.com';

const NEWZHENDI = '//test3.yx.jd.com/platform-marketing/CA040611033766380094';

// 黄金流程数字化服务平台【我京cms配置】
const WEJDPlat_DOMAIN: string = 'http://plat.jd.com';

// 频道标签平台
const EASYLABELPLAT_DOMAIN: string = 'https://easylabel-pb.jd.com';
// 三超CMS【京东三超】
const CICADA_DOMAIN: string = 'https://cicada-pro.pf.jd.com';

// 关注组件地址
const FOCUS_COMPONENT_URL = '//pickcms.jd.com';
// 屏蔽策略地址
const DISCOUNT_RULE_CMS = 'https://discountRuleCms-pro.pf.jd.com';

// ducc域名
const DUCC_DOMAIN: string = '//beta-api.m.jd.com';
const DUCC_CHANNEL: string = 'hdpreview_pre';
const LONG_MISSION: object = {
  ANENUE_CHECK_CODE: 'BIZ10000002',
  ANENUE_OFFLINE_CODE: 'BIZ10000005',
  ANENUE_GOBACK_CODE: 'BIZ10000006',
  ANENUE_EXPORT_CODE: 'BIZ10000003',
  MATERIAL_EXPORT_CODE: 'BIZ10000007',
  RULES_UPLOAD: 'BIZ10000009',
  PRODUCT_GROP: 'BIZ10000010',
  BATCH_QUIT_UPLOAD: 'BIZ10000011',
};

const GLOBAL_FEEDBACK_JS: string = 'http://storage.jd.local/yx.jd/yx-feedback/release/index.umd.js';
// 排行榜
const RANK_LIST: string = 'https://rankcms.jd.com';

const NEW_PANDORA: string = 'http://prod-test.xpyx.jd.com/';

// 用户运营中心
const USER_OPERATE: string = 'https://user-operations-pro.pf.jd.com/';

//推荐
const RECOMMEND_OPERATE: string = 'https://copbiz.jd.com/';
// 搜索
const SEARCH_OPERATE: string = 'https://srop-cms.jd.com/?logo=none';
//黄流
const GOLD_OPERATE: string = 'https://hl.jd.com/#/operation/jdapp/gold';

// auth 权限管理
const AUTH_DOMAIN: string = '//auth.jd.com';
const AUTH_SYSTEM_CODE: string = 'CFhENCsBruIxtxjC';
const ACE_DUCC_KEY: string = 'sourceCms.selection.new.path.typeset';
// 黄金流线上和预发区分参数
const GOLD_SEARCH: object = {
  OPERATE: '#/goods',
  MANAGE: '#/domain',
};

// 品类自助
const CATEGORY_DIY_URL: string = 'http://6a-bdp.jd.com/dmPage/homeYX?dmIframeSysType=e2eYX';

// 新品运营中心配置
const NEWPRODCONF_URL = 'http://dripworks-5193j2fz-pro.local-pf.jd.com';
const RANK_ADMIN_URL = 'http://dripworks-g6ghczdc-beta.local-pf.jd.com';

// 京麦内嵌域名
const JM_DOMAIN = 'https://osw.jd.com';

// 白名单OA审批
const WHITE_OA_DOMAIN = '//joysky.jd.com';

// 搭售运营
const DASHOU_YUNYING_URL: string = 'https://ossin.jd.com/swm-plus/in-operation/index.html#/';
// 情报中心
const INFORMATION_CENTER: string = 'https://dripworks-jy8av3gc-pro.local-pf.jd.com/#/';
//标签平台/经海路
const JINGHAILU: string = 'https://jinghailu-product.jd.com';

//USER_REACH用户触达
const USER_REACH: string = 'https://reach-pro.local-pf.jd.com/';
//C2B
const C2B_LINK: string = 'http://c-b.jd.com/';
const C2B_SETTING: string = 'http://dripworks-vp7rc88z-pro.local-pf.jd.com/#/';
//变价上券引导查询id
const CHANGE_PRICE_ID = 908;
//drip-数据源
const DRIP_SOURCE: string = 'http://drip-splatform.jd.com/service/api/v1/invoke/5byxkRDx';

// 桃花岛
const PEACH_BLOSSOM = {
  MAIN: '//mesher.jd.com/grid-webs/thd.html#/guide',
  LEO_AUTO: '//4a-bdp.jd.com/leoauto/peach/plan/list?from=ge&dmIframeSysType=peachYX',
  DM_PAGE: '//4a-bdp.jd.com/dmPage/peach/effect/list?from=ge&dmIframeSysType=peachYX',
};

const value: ENV = {
  API_ENV,
  USER_OPERATE,
  RECOMMEND_OPERATE,
  SEARCH_OPERATE,
  GOLD_OPERATE,
  GOLD_SEARCH,
  FOCUS_COMPONENT_URL,
  ACORE_DOMAIN,
  TREND_DOMAIN,
  HD_API_DOMAIN,
  MC_DOMAIN,
  MC_LOWCODE_PAGE,
  MAC_DOMAIN,
  ACE_DOMAIN,
  ACE_API_DOMAIN,
  DATA_CENTER_DOMAIN,
  EASYBI_DOMAIN,
  EASYBI_URL_DOMAIN,
  BABEL_DOMAIN,
  LINGLONG_DOMAIN,
  BABELPRO_DOMAIN,
  BABELPRO_PARAMS,
  BABELPRO_PC_DOMAIN,
  CELUE_DOMAIN,
  QYPT_DOMAIN,
  WAREOPS_DOMAIN,
  BAICHUAN_DOMAIN,
  SECKILLCMS_DOMAIN,
  DRIPWORKS_DOMAIN,
  NEWPROCESS,
  NEWZHENDI,
  WEJDPlat_DOMAIN,
  EASYLABELPLAT_DOMAIN,
  CICADA_DOMAIN,
  HD_API_TOOL_DOMAIN,
  DUCC_DOMAIN,
  DUCC_CHANNEL,
  LONG_MISSION,
  RANK_LIST,
  DRIPWORKS_DOMAIN_SYSTEM,
  GLOBAL_FEEDBACK_JS,
  DISCOUNT_RULE_CMS,
  NEW_PANDORA,
  AUTH_DOMAIN,
  AUTH_SYSTEM_CODE,
  CATEGORY_DIY_URL,
  ACE_DUCC_KEY,
  NEWPRODCONF_URL,
  RANK_ADMIN_URL,
  JM_DOMAIN,
  WHITE_OA_DOMAIN,
  venuesPageDetailPageId: 31,
  DASHOU_YUNYING_URL,
  INFORMATION_CENTER,
  JINGHAILU,
  USER_REACH,
  C2B_LINK,
  C2B_SETTING,
  CHANGE_PRICE_ID,
  DRIP_SOURCE,
  PEACH_BLOSSOM,
};

export default value;
